import {
  observable, makeObservable,
} from 'mobx';
import { Axios } from '../utilities/network';
import RootStore from './root-store';
import { SetLocalStorage } from '../utilities/cryptography';
import { CURRENT_PLATFORM } from '../constants/settings';
import { PAGE_SIZE } from '../constants/options';
import { GetLangKey, GetUserProfile, Language } from '../utilities/general';
import { STREET_TYPE } from '../constants/storage-keys';


export default class OptionStore {
  loading: boolean = false;
  deleting: boolean = false;

  rootStore: RootStore;

  constructor(rootStore: RootStore) {
    makeObservable(this, {
      loading: observable,
    });
    this.rootStore = rootStore;
  }

  searchAddress = async (skip: number, take: number = PAGE_SIZE, reqModel: any = {}) => {
    this.loading = true;
    try {
      const res = await Axios.post(`/api/Address/Postcode/Search/${skip}/${take}?platformId=${CURRENT_PLATFORM}`, reqModel);
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loading = false;
    }
  };

  searchAddressStreetType = async (skip: number = 0, take: number = 0, reqModel: any = {}) => {
    this.loading = true;
    try {
      const res = await Axios.post(`/api/Address/StreetType/Search/${skip}/${take}?platformId=${CURRENT_PLATFORM}`, reqModel);
      const items = res.data.items;
      SetLocalStorage(STREET_TYPE, items.map((item: any) => ({ label: item.fullName, value: item.abbrName, id: item.id })));
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loading = false;
    }
  };

}
